module.exports = __webpack_public_path__ + "mainassets/img/minus.af3acca2.svg";